import React, { useEffect, useState } from 'react';
import { useDispatch }       from 'react-redux';
import { RiShoppingBagLine } from 'react-icons/ri';
import Card                  from '@/components/ui/cards/Card';
import { getOrderService }   from '@/services/OrderServices';

export default function OrdersTab({ adminId }) {
  const dispatch = useDispatch();
  const [orders,  setOrders]  = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(getOrderService({ userId: adminId }))
      .then(res => setOrders(res.data?.data?.data || []))
      .finally(() => setLoading(false));
  }, [adminId, dispatch]);

  return (
    <Card className="rounded-xl border border-gray-200 bg-white px-6 pt-6 pb-6">
      {/* Icon + heading */}
      <div className="flex items-center gap-2 mb-4">
        <RiShoppingBagLine className="text-xl text-slate-700" />
        <h3 className="text-lg font-medium">Orders</h3>
      </div>

      {loading ? (
        <div className="text-center p-6">Loading orders…</div>
      ) : orders.length === 0 ? (
        <div className="text-center text-gray-500 p-6">No data available.</div>
      ) : (
        <ul className="space-y-4">
          {orders.map(o => (
            <li key={o._id} className="p-4 border rounded">
              Order #{o._id} —{' '}
              {new Date(o.createdAt).toLocaleDateString()}
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
}
